export const COUNTRY_CODES = [
  {
      "name": "Afghanistan",
      "code": "AF",
      "dial_code": "+93",
      "flag": "🇦🇫",
      "currency_name": "Afghan Afghani",
      "currency": "AFN",
      "currency_symbol": "؋"
  },
  {
      "name": "Albania",
      "code": "AL",
      "dial_code": "+355",
      "flag": "🇦🇱",
      "currency_name": "Albanian Lek",
      "currency": "ALL",
      "currency_symbol": "L"
  },
  {
      "name": "Algeria",
      "code": "DZ",
      "dial_code": "+213",
      "flag": "🇩🇿",
      "currency_name": "Algerian Dinar",
      "currency": "DZD",
      "currency_symbol": "د.ج"
  },
  {
      "name": "Andorra",
      "code": "AD",
      "dial_code": "+376",
      "flag": "🇦🇩",
      "currency_name": "Euro",
      "currency": "EUR",
      "currency_symbol": "€"
  },
  {
      "name": "Angola",
      "code": "AO",
      "dial_code": "+244",
      "flag": "🇦🇴",
      "currency_name": "Angolan Kwanza",
      "currency": "AOA",
      "currency_symbol": "Kz"
  },
  {
      "name": "Antigua and Barbuda",
      "code": "AG",
      "dial_code": "+1268",
      "flag": "🇦🇬",
      "currency_name": "East Caribbean Dollar",
      "currency": "XCD",
      "currency_symbol": "$"
  },
  {
      "name": "Argentina",
      "code": "AR",
      "dial_code": "+54",
      "flag": "🇦🇷",
      "currency_name": "Argentine Peso",
      "currency": "ARS",
      "currency_symbol": "$"
  },
  {
      "name": "Armenia",
      "code": "AM",
      "dial_code": "+374",
      "flag": "🇦🇲",
      "currency_name": "Armenian Dram",
      "currency": "AMD",
      "currency_symbol": "֏"
  },
  {
      "name": "Australia",
      "code": "AU",
      "dial_code": "+61",
      "flag": "🇦🇺",
      "currency_name": "Australian Dollar",
      "currency": "AUD",
      "currency_symbol": "$"
  },
  {
      "name": "Austria",
      "code": "AT",
      "dial_code": "+43",
      "flag": "🇦🇹",
      "currency_name": "Euro",
      "currency": "EUR",
      "currency_symbol": "€"
  },
  {
      "name": "Azerbaijan",
      "code": "AZ",
      "dial_code": "+994",
      "flag": "🇦🇿",
      "currency_name": "Azerbaijani Manat",
      "currency": "AZN",
      "currency_symbol": "₼"
  },
  {
      "name": "Bahamas",
      "code": "BS",
      "dial_code": "+1242",
      "flag": "🇧🇸",
      "currency_name": "Bahamian Dollar",
      "currency": "BSD",
      "currency_symbol": "$"
  },
  {
      "name": "Bahrain",
      "code": "BH",
      "dial_code": "+973",
      "flag": "🇧🇭",
      "currency_name": "Bahraini Dinar",
      "currency": "BHD",
      "currency_symbol": ".د.ب"
  },
  {
      "name": "Bangladesh",
      "code": "BD",
      "dial_code": "+880",
      "flag": "🇧🇩",
      "currency_name": "Bangladeshi Taka",
      "currency": "BDT",
      "currency_symbol": "৳"
  },
  {
      "name": "Barbados",
      "code": "BB",
      "dial_code": "+1246",
      "flag": "🇧🇧",
      "currency_name": "Barbadian Dollar",
      "currency": "BBD",
      "currency_symbol": "$"
  },
  {
      "name": "Belarus",
      "code": "BY",
      "dial_code": "+375",
      "flag": "🇧🇾",
      "currency_name": "Belarusian Ruble",
      "currency": "BYN",
      "currency_symbol": "Br"
  },
  {
      "name": "Belgium",
      "code": "BE",
      "dial_code": "+32",
      "flag": "🇧🇪",
      "currency_name": "Euro",
      "currency": "EUR",
      "currency_symbol": "€"
  },
  {
      "name": "Belize",
      "code": "BZ",
      "dial_code": "+501",
      "flag": "🇧🇿",
      "currency_name": "Belize Dollar",
      "currency": "BZD",
      "currency_symbol": "$"
  },
  {
      "name": "Benin",
      "code": "BJ",
      "dial_code": "+229",
      "flag": "🇧🇯",
      "currency_name": "West African CFA Franc",
      "currency": "XOF",
      "currency_symbol": "Fr"
  },
  {
      "name": "Bhutan",
      "code": "BT",
      "dial_code": "+975",
      "flag": "🇧🇹",
      "currency_name": "Bhutanese Ngultrum",
      "currency": "BTN",
      "currency_symbol": "Nu."
  },
  {
      "name": "Bolivia",
      "code": "BO",
      "dial_code": "+591",
      "flag": "🇧🇴",
      "currency_name": "Bolivian Boliviano",
      "currency": "BOB",
      "currency_symbol": "Bs."
  },
  {
      "name": "Bosnia and Herzegovina",
      "code": "BA",
      "dial_code": "+387",
      "flag": "🇧🇦",
      "currency_name": "Convertible Mark",
      "currency": "BAM",
      "currency_symbol": "KM"
  },
  {
      "name": "Botswana",
      "code": "BW",
      "dial_code": "+267",
      "flag": "🇧🇼",
      "currency_name": "Botswana Pula",
      "currency": "BWP",
      "currency_symbol": "P"
  },
  {
      "name": "Brazil",
      "code": "BR",
      "dial_code": "+55",
      "flag": "🇧🇷",
      "currency_name": "Brazilian Real",
      "currency": "BRL",
      "currency_symbol": "R$"
  },
  {
      "name": "Brunei",
      "code": "BN",
      "dial_code": "+673",
      "flag": "🇧🇳",
      "currency_name": "Brunei Dollar",
      "currency": "BND",
      "currency_symbol": "$"
  },
  {
      "name": "Bulgaria",
      "code": "BG",
      "dial_code": "+359",
      "flag": "🇧🇬",
      "currency_name": "Bulgarian Lev",
      "currency": "BGN",
      "currency_symbol": "лв"
  },
  {
      "name": "Burkina Faso",
      "code": "BF",
      "dial_code": "+226",
      "flag": "🇧🇫",
      "currency_name": "West African CFA Franc",
      "currency": "XOF",
      "currency_symbol": "Fr"
  },
  {
      "name": "Burundi",
      "code": "BI",
      "dial_code": "+257",
      "flag": "🇧🇮",
      "currency_name": "Burundian Franc",
      "currency": "BIF",
      "currency_symbol": "Fr"
  },
  {
      "name": "Cambodia",
      "code": "KH",
      "dial_code": "+855",
      "flag": "🇰🇭",
      "currency_name": "Cambodian Riel",
      "currency": "KHR",
      "currency_symbol": "៛"
  },
  {
      "name": "Cameroon",
      "code": "CM",
      "dial_code": "+237",
      "flag": "🇨🇲",
      "currency_name": "Central African CFA Franc",
      "currency": "XAF",
      "currency_symbol": "Fr"
  },
  {
      "name": "Canada",
      "code": "CA",
      "dial_code": "+1",
      "flag": "🇨🇦",
      "currency_name": "Canadian Dollar",
      "currency": "CAD",
      "currency_symbol": "$"
  },
  {
      "name": "Cape Verde",
      "code": "CV",
      "dial_code": "+238",
      "flag": "🇨🇻",
      "currency_name": "Cape Verdean Escudo",
      "currency": "CVE",
      "currency_symbol": "$"
  },
  {
      "name": "Central African Republic",
      "code": "CF",
      "dial_code": "+236",
      "flag": "🇨🇫",
      "currency_name": "Central African CFA Franc",
      "currency": "XAF",
      "currency_symbol": "Fr"
  },
  {
      "name": "Chad",
      "code": "TD",
      "dial_code": "+235",
      "flag": "🇹🇩",
      "currency_name": "Central African CFA Franc",
      "currency": "XAF",
      "currency_symbol": "Fr"
  },
  {
      "name": "Chile",
      "code": "CL",
      "dial_code": "+56",
      "flag": "🇨🇱",
      "currency_name": "Chilean Peso",
      "currency": "CLP",
      "currency_symbol": "$"
  },
  {
      "name": "China",
      "code": "CN",
      "dial_code": "+86",
      "flag": "🇨🇳",
      "currency_name": "Chinese Yuan",
      "currency": "CNY",
      "currency_symbol": "¥"
  },
  {
      "name": "Colombia",
      "code": "CO",
      "dial_code": "+57",
      "flag": "🇨🇴",
      "currency_name": "Colombian Peso",
      "currency": "COP",
      "currency_symbol": "$"
  },
  {
      "name": "Comoros",
      "code": "KM",
      "dial_code": "+269",
      "flag": "🇰🇲",
      "currency_name": "Comorian Franc",
      "currency": "KMF",
      "currency_symbol": "Fr"
  },
  {
      "name": "Congo (Democratic Republic)",
      "code": "CD",
      "dial_code": "+243",
      "flag": "🇨🇩",
      "currency_name": "Congolese Franc",
      "currency": "CDF",
      "currency_symbol": "Fr"
  },
  {
      "name": "Congo (Republic)",
      "code": "CG",
      "dial_code": "+242",
      "flag": "🇨🇬",
      "currency_name": "Central African CFA Franc",
      "currency": "XAF",
      "currency_symbol": "Fr"
  },
  {
      "name": "Costa Rica",
      "code": "CR",
      "dial_code": "+506",
      "flag": "🇨🇷",
      "currency_name": "Costa Rican Colón",
      "currency": "CRC",
      "currency_symbol": "₡"
  },
  {
      "name": "Croatia",
      "code": "HR",
      "dial_code": "+385",
      "flag": "🇭🇷",
      "currency_name": "Euro",
      "currency": "EUR",
      "currency_symbol": "€"
  },
  {
      "name": "Cuba",
      "code": "CU",
      "dial_code": "+53",
      "flag": "🇨🇺",
      "currency_name": "Cuban Peso",
      "currency": "CUP",
      "currency_symbol": "$"
  },
  {
      "name": "Cyprus",
      "code": "CY",
      "dial_code": "+357",
      "flag": "🇨🇾",
      "currency_name": "Euro",
      "currency": "EUR",
      "currency_symbol": "€"
  },
  {
      "name": "Czech Republic",
      "code": "CZ",
      "dial_code": "+420",
      "flag": "🇨🇿",
      "currency_name": "Czech Koruna",
      "currency": "CZK",
      "currency_symbol": "Kč"
  },
  {
      "name": "Denmark",
      "code": "DK",
      "dial_code": "+45",
      "flag": "🇩🇰",
      "currency_name": "Danish Krone",
      "currency": "DKK",
      "currency_symbol": "kr"
  },
  {
      "name": "Djibouti",
      "code": "DJ",
      "dial_code": "+253",
      "flag": "🇩🇯",
      "currency_name": "Djiboutian Franc",
      "currency": "DJF",
      "currency_symbol": "Fr"
  },
  {
      "name": "Dominica",
      "code": "DM",
      "dial_code": "+1767",
      "flag": "🇩🇲",
      "currency_name": "East Caribbean Dollar",
      "currency": "XCD",
      "currency_symbol": "$"
  },
  {
      "name": "Dominican Republic",
      "code": "DO",
      "dial_code": "+1",
      "flag": "🇩🇴",
      "currency_name": "Dominican Peso",
      "currency": "DOP",
      "currency_symbol": "$"
  },
  {
      "name": "East Timor",
      "code": "TL",
      "dial_code": "+670",
      "flag": "🇹🇱",
      "currency_name": "United States Dollar",
      "currency": "USD",
      "currency_symbol": "$"
  },
  {
      "name": "Ecuador",
      "code": "EC",
      "dial_code": "+593",
      "flag": "🇪🇨",
      "currency_name": "United States Dollar",
      "currency": "USD",
      "currency_symbol": "$"
  },
  {
      "name": "Egypt",
      "code": "EG",
      "dial_code": "+20",
      "flag": "🇪🇬",
      "currency_name": "Egyptian Pound",
      "currency": "EGP",
      "currency_symbol": "£"
  },
  {
      "name": "El Salvador",
      "code": "SV",
      "dial_code": "+503",
      "flag": "🇸🇻",
      "currency_name": "United States Dollar",
      "currency": "USD",
      "currency_symbol": "$"
  },
  {
      "name": "Equatorial Guinea",
      "code": "GQ",
      "dial_code": "+240",
      "flag": "🇬🇶",
      "currency_name": "Central African CFA Franc",
      "currency": "XAF",
      "currency_symbol": "Fr"
  },
  {
      "name": "Eritrea",
      "code": "ER",
      "dial_code": "+291",
      "flag": "🇪🇷",
      "currency_name": "Eritrean Nakfa",
      "currency": "ERN",
      "currency_symbol": "Nfk"
  },
  {
      "name": "Estonia",
      "code": "EE",
      "dial_code": "+372",
      "flag": "🇪🇪",
      "currency_name": "Euro",
      "currency": "EUR",
      "currency_symbol": "€"
  },
  {
      "name": "Eswatini",
      "code": "SZ",
      "dial_code": "+268",
      "flag": "🇸🇿",
      "currency_name": "Swazi Lilangeni",
      "currency": "SZL",
      "currency_symbol": "L"
  },
  {
      "name": "Ethiopia",
      "code": "ET",
      "dial_code": "+251",
      "flag": "🇪🇹",
      "currency_name": "Ethiopian Birr",
      "currency": "ETB",
      "currency_symbol": "Br"
  },
  {
      "name": "Fiji",
      "code": "FJ",
      "dial_code": "+679",
      "flag": "🇫🇯",
      "currency_name": "Fijian Dollar",
      "currency": "FJD",
      "currency_symbol": "$"
  },
  {
      "name": "Finland",
      "code": "FI",
      "dial_code": "+358",
      "flag": "🇫🇮",
      "currency_name": "Euro",
      "currency": "EUR",
      "currency_symbol": "€"
  },
  {
      "name": "France",
      "code": "FR",
      "dial_code": "+33",
      "flag": "🇫🇷",
      "currency_name": "Euro",
      "currency": "EUR",
      "currency_symbol": "€"
  },
  {
      "name": "Gabon",
      "code": "GA",
      "dial_code": "+241",
      "flag": "🇬🇦",
      "currency_name": "Central African CFA Franc",
      "currency": "XAF",
      "currency_symbol": "Fr"
  },
  {
      "name": "Gambia",
      "code": "GM",
      "dial_code": "+220",
      "flag": "🇬🇲",
      "currency_name": "Gambian Dalasi",
      "currency": "GMD",
      "currency_symbol": "D"
  },
  {
      "name": "Georgia",
      "code": "GE",
      "dial_code": "+995",
      "flag": "🇬🇪",
      "currency_name": "Georgian Lari",
      "currency": "GEL",
      "currency_symbol": "₾"
  },
  {
      "name": "Germany",
      "code": "DE",
      "dial_code": "+49",
      "flag": "🇩🇪",
      "currency_name": "Euro",
      "currency": "EUR",
      "currency_symbol": "€"
  },
  {
      "name": "Ghana",
      "code": "GH",
      "dial_code": "+233",
      "flag": "🇬🇭",
      "currency_name": "Ghanaian Cedi",
      "currency": "GHS",
      "currency_symbol": "₵"
  },
  {
      "name": "Greece",
      "code": "GR",
      "dial_code": "+30",
      "flag": "🇬🇷",
      "currency_name": "Euro",
      "currency": "EUR",
      "currency_symbol": "€"
  },
  {
      "name": "Grenada",
      "code": "GD",
      "dial_code": "+1473",
      "flag": "🇬🇩",
      "currency_name": "East Caribbean Dollar",
      "currency": "XCD",
      "currency_symbol": "$"
  },
  {
      "name": "Guatemala",
      "code": "GT",
      "dial_code": "+502",
      "flag": "🇬🇹",
      "currency_name": "Guatemalan Quetzal",
      "currency": "GTQ",
      "currency_symbol": "Q"
  },
  {
      "name": "Guinea",
      "code": "GN",
      "dial_code": "+224",
      "flag": "🇬🇳",
      "currency_name": "Guinean Franc",
      "currency": "GNF",
      "currency_symbol": "Fr"
  },
  {
      "name": "Guinea-Bissau",
      "code": "GW",
      "dial_code": "+245",
      "flag": "🇬🇼",
      "currency_name": "West African CFA Franc",
      "currency": "XOF",
      "currency_symbol": "Fr"
  },
  {
      "name": "Guyana",
      "code": "GY",
      "dial_code": "+592",
      "flag": "🇬🇾",
      "currency_name": "Guyanese Dollar",
      "currency": "GYD",
      "currency_symbol": "$"
  },
  {
      "name": "Haiti",
      "code": "HT",
      "dial_code": "+509",
      "flag": "🇭🇹",
      "currency_name": "Haitian Gourde",
      "currency": "HTG",
      "currency_symbol": "G"
  },
  {
      "name": "Honduras",
      "code": "HN",
      "dial_code": "+504",
      "flag": "🇭🇳",
      "currency_name": "Honduran Lempira",
      "currency": "HNL",
      "currency_symbol": "L"
  },
  {
      "name": "Hungary",
      "code": "HU",
      "dial_code": "+36",
      "flag": "🇭🇺",
      "currency_name": "Hungarian Forint",
      "currency": "HUF",
      "currency_symbol": "Ft"
  },
  {
      "name": "Iceland",
      "code": "IS",
      "dial_code": "+354",
      "flag": "🇮🇸",
      "currency_name": "Icelandic Króna",
      "currency": "ISK",
      "currency_symbol": "kr"
  },
  {
      "name": "India",
      "code": "IN",
      "dial_code": "+91",
      "flag": "🇮🇳",
      "currency_name": "Indian Rupee",
      "currency": "INR",
      "currency_symbol": "₹"
  },
  {
      "name": "Indonesia",
      "code": "ID",
      "dial_code": "+62",
      "flag": "🇮🇩",
      "currency_name": "Indonesian Rupiah",
      "currency": "IDR",
      "currency_symbol": "Rp"
  },
  {
      "name": "Iran",
      "code": "IR",
      "dial_code": "+98",
      "flag": "🇮🇷",
      "currency_name": "Iranian Rial",
      "currency": "IRR",
      "currency_symbol": "﷼"
  },
  {
      "name": "Iraq",
      "code": "IQ",
      "dial_code": "+964",
      "flag": "🇮🇶",
      "currency_name": "Iraqi Dinar",
      "currency": "IQD",
      "currency_symbol": "ع.د"
  },
  {
      "name": "Ireland",
      "code": "IE",
      "dial_code": "+353",
      "flag": "🇮🇪",
      "currency_name": "Euro",
      "currency": "EUR",
      "currency_symbol": "€"
  },
  {
      "name": "Israel",
      "code": "IL",
      "dial_code": "+972",
      "flag": "🇮🇱",
      "currency_name": "Israeli New Shekel",
      "currency": "ILS",
      "currency_symbol": "₪"
  },
  {
      "name": "Italy",
      "code": "IT",
      "dial_code": "+39",
      "flag": "🇮🇹",
      "currency_name": "Euro",
      "currency": "EUR",
      "currency_symbol": "€"
  },
  {
      "name": "Ivory Coast",
      "code": "CI",
      "dial_code": "+225",
      "flag": "🇨🇮",
      "currency_name": "West African CFA Franc",
      "currency": "XOF",
      "currency_symbol": "Fr"
  },
  {
      "name": "Jamaica",
      "code": "JM",
      "dial_code": "+1876",
      "flag": "🇯🇲",
      "currency_name": "Jamaican Dollar",
      "currency": "JMD",
      "currency_symbol": "$"
  },
  {
      "name": "Japan",
      "code": "JP",
      "dial_code": "+81",
      "flag": "🇯🇵",
      "currency_name": "Japanese Yen",
      "currency": "JPY",
      "currency_symbol": "¥"
  },
  {
      "name": "Jordan",
      "code": "JO",
      "dial_code": "+962",
      "flag": "🇯🇴",
      "currency_name": "Jordanian Dinar",
      "currency": "JOD",
      "currency_symbol": "د.ا"
  },
  {
      "name": "Kazakhstan",
      "code": "KZ",
      "dial_code": "+7",
      "flag": "🇰🇿",
      "currency_name": "Kazakhstani Tenge",
      "currency": "KZT",
      "currency_symbol": "₸"
  },
  {
      "name": "Kenya",
      "code": "KE",
      "dial_code": "+254",
      "flag": "🇰🇪",
      "currency_name": "Kenyan Shilling",
      "currency": "KES",
      "currency_symbol": "KSh"
  },
  {
      "name": "Kiribati",
      "code": "KI",
      "dial_code": "+686",
      "flag": "🇰🇮",
      "currency_name": "Australian Dollar",
      "currency": "AUD",
      "currency_symbol": "$"
  },
  {
      "name": "Kuwait",
      "code": "KW",
      "dial_code": "+965",
      "flag": "🇰🇼",
      "currency_name": "Kuwaiti Dinar",
      "currency": "KWD",
      "currency_symbol": "د.ك"
  },
  {
      "name": "Kyrgyzstan",
      "code": "KG",
      "dial_code": "+996",
      "flag": "🇰🇬",
      "currency_name": "Kyrgyzstani Som",
      "currency": "KGS",
      "currency_symbol": "с"
  },
  {
      "name": "Laos",
      "code": "LA",
      "dial_code": "+856",
      "flag": "🇱🇦",
      "currency_name": "Lao Kip",
      "currency": "LAK",
      "currency_symbol": "₭"
  },
  {
      "name": "Latvia",
      "code": "LV",
      "dial_code": "+371",
      "flag": "🇱🇻",
      "currency_name": "Euro",
      "currency": "EUR",
      "currency_symbol": "€"
  },
  {
      "name": "Lebanon",
      "code": "LB",
      "dial_code": "+961",
      "flag": "🇱🇧",
      "currency_name": "Lebanese Pound",
      "currency": "LBP",
      "currency_symbol": "ل.ل"
  },
  {
      "name": "Lesotho",
      "code": "LS",
      "dial_code": "+266",
      "flag": "🇱🇸",
      "currency_name": "Lesotho Loti",
      "currency": "LSL",
      "currency_symbol": "L"
  },
  {
      "name": "Liberia",
      "code": "LR",
      "dial_code": "+231",
      "flag": "🇱🇷",
      "currency_name": "Liberian Dollar",
      "currency": "LRD",
      "currency_symbol": "$"
  },
  {
      "name": "Libya",
      "code": "LY",
      "dial_code": "+218",
      "flag": "🇱🇾",
      "currency_name": "Libyan Dinar",
      "currency": "LYD",
      "currency_symbol": "ل.د"
  },
  {
      "name": "Liechtenstein",
      "code": "LI",
      "dial_code": "+423",
      "flag": "🇱🇮",
      "currency_name": "Swiss Franc",
      "currency": "CHF",
      "currency_symbol": "CHF"
  },
  {
      "name": "Lithuania",
      "code": "LT",
      "dial_code": "+370",
      "flag": "🇱🇹",
      "currency_name": "Euro",
      "currency": "EUR",
      "currency_symbol": "€"
  },
  {
      "name": "Luxembourg",
      "code": "LU",
      "dial_code": "+352",
      "flag": "🇱🇺",
      "currency_name": "Euro",
      "currency": "EUR",
      "currency_symbol": "€"
  },
  {
      "name": "Madagascar",
      "code": "MG",
      "dial_code": "+261",
      "flag": "🇲🇬",
      "currency_name": "Malagasy Ariary",
      "currency": "MGA",
      "currency_symbol": "Ar"
  },
  {
      "name": "Malawi",
      "code": "MW",
      "dial_code": "+265",
      "flag": "🇲🇼",
      "currency_name": "Malawian Kwacha",
      "currency": "MWK",
      "currency_symbol": "MK"
  },
  {
      "name": "Malaysia",
      "code": "MY",
      "dial_code": "+60",
      "flag": "🇲🇾",
      "currency_name": "Malaysian Ringgit",
      "currency": "MYR",
      "currency_symbol": "RM"
  },
  {
      "name": "Maldives",
      "code": "MV",
      "dial_code": "+960",
      "flag": "🇲🇻",
      "currency_name": "Maldivian Rufiyaa",
      "currency": "MVR",
      "currency_symbol": ".ރ"
  },
  {
      "name": "Mali",
      "code": "ML",
      "dial_code": "+223",
      "flag": "🇲🇱",
      "currency_name": "West African CFA Franc",
      "currency": "XOF",
      "currency_symbol": "Fr"
  },
  {
      "name": "Malta",
      "code": "MT",
      "dial_code": "+356",
      "flag": "🇲🇹",
      "currency_name": "Euro",
      "currency": "EUR",
      "currency_symbol": "€"
  },
  {
      "name": "Marshall Islands",
      "code": "MH",
      "dial_code": "+692",
      "flag": "🇲🇭",
      "currency_name": "United States Dollar",
      "currency": "USD",
      "currency_symbol": "$"
  },
  {
      "name": "Mauritania",
      "code": "MR",
      "dial_code": "+222",
      "flag": "🇲🇷",
      "currency_name": "Mauritanian Ouguiya",
      "currency": "MRU",
      "currency_symbol": "UM"
  },
  {
      "name": "Mauritius",
      "code": "MU",
      "dial_code": "+230",
      "flag": "🇲🇺",
      "currency_name": "Mauritian Rupee",
      "currency": "MUR",
      "currency_symbol": "₨"
  },
  {
      "name": "Mexico",
      "code": "MX",
      "dial_code": "+52",
      "flag": "🇲🇽",
      "currency_name": "Mexican Peso",
      "currency": "MXN",
      "currency_symbol": "$"
  },
  {
      "name": "Micronesia",
      "code": "FM",
      "dial_code": "+691",
      "flag": "🇫🇲",
      "currency_name": "United States Dollar",
      "currency": "USD",
      "currency_symbol": "$"
  },
  {
      "name": "Moldova",
      "code": "MD",
      "dial_code": "+373",
      "flag": "🇲🇩",
      "currency_name": "Moldovan Leu",
      "currency": "MDL",
      "currency_symbol": "L"
  },
  {
      "name": "Monaco",
      "code": "MC",
      "dial_code": "+377",
      "flag": "🇲🇨",
      "currency_name": "Euro",
      "currency": "EUR",
      "currency_symbol": "€"
  },
  {
      "name": "Mongolia",
      "code": "MN",
      "dial_code": "+976",
      "flag": "🇲🇳",
      "currency_name": "Mongolian Tögrög",
      "currency": "MNT",
      "currency_symbol": "₮"
  },
  {
      "name": "Montenegro",
      "code": "ME",
      "dial_code": "+382",
      "flag": "🇲🇪",
      "currency_name": "Euro",
      "currency": "EUR",
      "currency_symbol": "€"
  },
  {
      "name": "Morocco",
      "code": "MA",
      "dial_code": "+212",
      "flag": "🇲🇦",
      "currency_name": "Moroccan Dirham",
      "currency": "MAD",
      "currency_symbol": "د.م."
  },
  {
      "name": "Mozambique",
      "code": "MZ",
      "dial_code": "+258",
      "flag": "🇲🇿",
      "currency_name": "Mozambican Metical",
      "currency": "MZN",
      "currency_symbol": "MT"
  },
  {
      "name": "Myanmar",
      "code": "MM",
      "dial_code": "+95",
      "flag": "🇲🇲",
      "currency_name": "Burmese Kyat",
      "currency": "MMK",
      "currency_symbol": "K"
  },
  {
      "name": "Namibia",
      "code": "NA",
      "dial_code": "+264",
      "flag": "🇳🇦",
      "currency_name": "Namibian Dollar",
      "currency": "NAD",
      "currency_symbol": "$"
  },
  {
      "name": "Nauru",
      "code": "NR",
      "dial_code": "+674",
      "flag": "🇳🇷",
      "currency_name": "Australian Dollar",
      "currency": "AUD",
      "currency_symbol": "$"
  },
  {
      "name": "Nepal",
      "code": "NP",
      "dial_code": "+977",
      "flag": "🇳🇵",
      "currency_name": "Nepalese Rupee",
      "currency": "NPR",
      "currency_symbol": "₨"
  },
  {
      "name": "Netherlands",
      "code": "NL",
      "dial_code": "+31",
      "flag": "🇳🇱",
      "currency_name": "Euro",
      "currency": "EUR",
      "currency_symbol": "€"
  },
  {
      "name": "New Zealand",
      "code": "NZ",
      "dial_code": "+64",
      "flag": "🇳🇿",
      "currency_name": "New Zealand Dollar",
      "currency": "NZD",
      "currency_symbol": "$"
  },
  {
      "name": "Nicaragua",
      "code": "NI",
      "dial_code": "+505",
      "flag": "🇳🇮",
      "currency_name": "Nicaraguan Córdoba",
      "currency": "NIO",
      "currency_symbol": "C$"
  },
  {
      "name": "Niger",
      "code": "NE",
      "dial_code": "+227",
      "flag": "🇳🇪",
      "currency_name": "West African CFA Franc",
      "currency": "XOF",
      "currency_symbol": "Fr"
  },
  {
      "name": "Nigeria",
      "code": "NG",
      "dial_code": "+234",
      "flag": "🇳🇬",
      "currency_name": "Nigerian Naira",
      "currency": "NGN",
      "currency_symbol": "₦"
  },
  {
      "name": "North Korea",
      "code": "KP",
      "dial_code": "+850",
      "flag": "🇰🇵",
      "currency_name": "North Korean Won",
      "currency": "KPW",
      "currency_symbol": "₩"
  },
  {
      "name": "North Macedonia",
      "code": "MK",
      "dial_code": "+389",
      "flag": "🇲🇰",
      "currency_name": "Macedonian Denar",
      "currency": "MKD",
      "currency_symbol": "ден"
  },
  {
      "name": "Norway",
      "code": "NO",
      "dial_code": "+47",
      "flag": "🇳🇴",
      "currency_name": "Norwegian Krone",
      "currency": "NOK",
      "currency_symbol": "kr"
  },
  {
      "name": "Oman",
      "code": "OM",
      "dial_code": "+968",
      "flag": "🇴🇲",
      "currency_name": "Omani Rial",
      "currency": "OMR",
      "currency_symbol": "ر.ع."
  },
  {
      "name": "Pakistan",
      "code": "PK",
      "dial_code": "+92",
      "flag": "🇵🇰",
      "currency_name": "Pakistani Rupee",
      "currency": "PKR",
      "currency_symbol": "₨"
  },
  {
      "name": "Palau",
      "code": "PW",
      "dial_code": "+680",
      "flag": "🇵🇼",
      "currency_name": "United States Dollar",
      "currency": "USD",
      "currency_symbol": "$"
  },
  {
      "name": "Palestine",
      "code": "PS",
      "dial_code": "+970",
      "flag": "🇵🇸",
      "currency_name": "Israeli New Shekel",
      "currency": "ILS",
      "currency_symbol": "₪"
  },
  {
      "name": "Panama",
      "code": "PA",
      "dial_code": "+507",
      "flag": "🇵🇦",
      "currency_name": "Panamanian Balboa",
      "currency": "PAB",
      "currency_symbol": "B/."
  },
  {
      "name": "Papua New Guinea",
      "code": "PG",
      "dial_code": "+675",
      "flag": "🇵🇬",
      "currency_name": "Papua New Guinean Kina",
      "currency": "PGK",
      "currency_symbol": "K"
  },
  {
      "name": "Paraguay",
      "code": "PY",
      "dial_code": "+595",
      "flag": "🇵🇾",
      "currency_name": "Paraguayan Guaraní",
      "currency": "PYG",
      "currency_symbol": "₲"
  },
  {
      "name": "Peru",
      "code": "PE",
      "dial_code": "+51",
      "flag": "🇵🇪",
      "currency_name": "Peruvian Sol",
      "currency": "PEN",
      "currency_symbol": "S/"
  },
  {
      "name": "Philippines",
      "code": "PH",
      "dial_code": "+63",
      "flag": "🇵🇭",
      "currency_name": "Philippine Peso",
      "currency": "PHP",
      "currency_symbol": "₱"
  },
  {
      "name": "Poland",
      "code": "PL",
      "dial_code": "+48",
      "flag": "🇵🇱",
      "currency_name": "Polish Złoty",
      "currency": "PLN",
      "currency_symbol": "zł"
  },
  {
      "name": "Portugal",
      "code": "PT",
      "dial_code": "+351",
      "flag": "🇵🇹",
      "currency_name": "Euro",
      "currency": "EUR",
      "currency_symbol": "€"
  },
  {
      "name": "Qatar",
      "code": "QA",
      "dial_code": "+974",
      "flag": "🇶🇦",
      "currency_name": "Qatari Riyal",
      "currency": "QAR",
      "currency_symbol": "ر.ق"
  },
  {
      "name": "Romania",
      "code": "RO",
      "dial_code": "+40",
      "flag": "🇷🇴",
      "currency_name": "Romanian Leu",
      "currency": "RON",
      "currency_symbol": "lei"
  },
  {
      "name": "Russia",
      "code": "RU",
      "dial_code": "+7",
      "flag": "🇷🇺",
      "currency_name": "Russian Ruble",
      "currency": "RUB",
      "currency_symbol": "₽"
  },
  {
      "name": "Rwanda",
      "code": "RW",
      "dial_code": "+250",
      "flag": "🇷🇼",
      "currency_name": "Rwandan Franc",
      "currency": "RWF",
      "currency_symbol": "Fr"
  },
  {
      "name": "Saint Kitts and Nevis",
      "code": "KN",
      "dial_code": "+1869",
      "flag": "🇰🇳",
      "currency_name": "East Caribbean Dollar",
      "currency": "XCD",
      "currency_symbol": "$"
  },
  {
      "name": "Saint Lucia",
      "code": "LC",
      "dial_code": "+1758",
      "flag": "🇱🇨",
      "currency_name": "East Caribbean Dollar",
      "currency": "XCD",
      "currency_symbol": "$"
  },
  {
      "name": "Saint Vincent and the Grenadines",
      "code": "VC",
      "dial_code": "+1784",
      "flag": "🇻🇨",
      "currency_name": "East Caribbean Dollar",
      "currency": "XCD",
      "currency_symbol": "$"
  },
  {
      "name": "Samoa",
      "code": "WS",
      "dial_code": "+685",
      "flag": "🇼🇸",
      "currency_name": "Samoan Tālā",
      "currency": "WST",
      "currency_symbol": "T"
  },
  {
      "name": "San Marino",
      "code": "SM",
      "dial_code": "+378",
      "flag": "🇸🇲",
      "currency_name": "Euro",
      "currency": "EUR",
      "currency_symbol": "€"
  },
  {
      "name": "São Tomé and Príncipe",
      "code": "ST",
      "dial_code": "+239",
      "flag": "🇸🇹",
      "currency_name": "São Tomé and Príncipe Dobra",
      "currency": "STN",
      "currency_symbol": "Db"
  },
  {
      "name": "Saudi Arabia",
      "code": "SA",
      "dial_code": "+966",
      "flag": "🇸🇦",
      "currency_name": "Saudi Riyal",
      "currency": "SAR",
      "currency_symbol": "ر.س"
  },
  {
      "name": "Senegal",
      "code": "SN",
      "dial_code": "+221",
      "flag": "🇸🇳",
      "currency_name": "West African CFA Franc",
      "currency": "XOF",
      "currency_symbol": "Fr"
  },
  {
      "name": "Serbia",
      "code": "RS",
      "dial_code": "+381",
      "flag": "🇷🇸",
      "currency_name": "Serbian Dinar",
      "currency": "RSD",
      "currency_symbol": "дин"
  },
  {
      "name": "Seychelles",
      "code": "SC",
      "dial_code": "+248",
      "flag": "🇸🇨",
      "currency_name": "Seychellois Rupee",
      "currency": "SCR",
      "currency_symbol": "₨"
  },
  {
      "name": "Sierra Leone",
      "code": "SL",
      "dial_code": "+232",
      "flag": "🇸🇱",
      "currency_name": "Sierra Leonean Leone",
      "currency": "SLE",
      "currency_symbol": "Le"
  },
  {
      "name": "Singapore",
      "code": "SG",
      "dial_code": "+65",
      "flag": "🇸🇬",
      "currency_name": "Singapore Dollar",
      "currency": "SGD",
      "currency_symbol": "$"
  },
  {
      "name": "Slovakia",
      "code": "SK",
      "dial_code": "+421",
      "flag": "🇸🇰",
      "currency_name": "Euro",
      "currency": "EUR",
      "currency_symbol": "€"
  },
  {
      "name": "Slovenia",
      "code": "SI",
      "dial_code": "+386",
      "flag": "🇸🇮",
      "currency_name": "Euro",
      "currency": "EUR",
      "currency_symbol": "€"
  },
  {
      "name": "Solomon Islands",
      "code": "SB",
      "dial_code": "+677",
      "flag": "🇸🇧",
      "currency_name": "Solomon Islands Dollar",
      "currency": "SBD",
      "currency_symbol": "$"
  },
  {
      "name": "Somalia",
      "code": "SO",
      "dial_code": "+252",
      "flag": "🇸🇴",
      "currency_name": "Somali Shilling",
      "currency": "SOS",
      "currency_symbol": "Sh"
  },
  {
      "name": "South Africa",
      "code": "ZA",
      "dial_code": "+27",
      "flag": "🇿🇦",
      "currency_name": "South African Rand",
      "currency": "ZAR",
      "currency_symbol": "R"
  },
  {
      "name": "South Korea",
      "code": "KR",
      "dial_code": "+82",
      "flag": "🇰🇷",
      "currency_name": "South Korean Won",
      "currency": "KRW",
      "currency_symbol": "₩"
  },
  {
      "name": "South Sudan",
      "code": "SS",
      "dial_code": "+211",
      "flag": "🇸🇸",
      "currency_name": "South Sudanese Pound",
      "currency": "SSP",
      "currency_symbol": "£"
  },
  {
      "name": "Spain",
      "code": "ES",
      "dial_code": "+34",
      "flag": "🇪🇸",
      "currency_name": "Euro",
      "currency": "EUR",
      "currency_symbol": "€"
  },
  {
      "name": "Sri Lanka",
      "code": "LK",
      "dial_code": "+94",
      "flag": "🇱🇰",
      "currency_name": "Sri Lankan Rupee",
      "currency": "LKR",
      "currency_symbol": "₨"
  },
  {
      "name": "Sudan",
      "code": "SD",
      "dial_code": "+249",
      "flag": "🇸🇩",
      "currency_name": "Sudanese Pound",
      "currency": "SDG",
      "currency_symbol": "£"
  },
  {
      "name": "Suriname",
      "code": "SR",
      "dial_code": "+597",
      "flag": "🇸🇷",
      "currency_name": "Surinamese Dollar",
      "currency": "SRD",
      "currency_symbol": "$"
  },
  {
      "name": "Sweden",
      "code": "SE",
      "dial_code": "+46",
      "flag": "🇸🇪",
      "currency_name": "Swedish Krona",
      "currency": "SEK",
      "currency_symbol": "kr"
  },
  {
      "name": "Switzerland",
      "code": "CH",
      "dial_code": "+41",
      "flag": "🇨🇭",
      "currency_name": "Swiss Franc",
      "currency": "CHF",
      "currency_symbol": "CHF"
  },
  {
      "name": "Syria",
      "code": "SY",
      "dial_code": "+963",
      "flag": "🇸🇾",
      "currency_name": "Syrian Pound",
      "currency": "SYP",
      "currency_symbol": "£"
  },
  {
      "name": "Tajikistan",
      "code": "TJ",
      "dial_code": "+992",
      "flag": "🇹🇯",
      "currency_name": "Tajikistani Somoni",
      "currency": "TJS",
      "currency_symbol": "SM"
  },
  {
      "name": "Tanzania",
      "code": "TZ",
      "dial_code": "+255",
      "flag": "🇹🇿",
      "currency_name": "Tanzanian Shilling",
      "currency": "TZS",
      "currency_symbol": "Sh"
  },
  {
      "name": "Thailand",
      "code": "TH",
      "dial_code": "+66",
      "flag": "🇹🇭",
      "currency_name": "Thai Baht",
      "currency": "THB",
      "currency_symbol": "฿"
  },
  {
      "name": "Togo",
      "code": "TG",
      "dial_code": "+228",
      "flag": "🇹🇬",
      "currency_name": "West African CFA Franc",
      "currency": "XOF",
      "currency_symbol": "Fr"
  },
  {
      "name": "Tonga",
      "code": "TO",
      "dial_code": "+676",
      "flag": "🇹🇴",
      "currency_name": "Tongan Paʻanga",
      "currency": "TOP",
      "currency_symbol": "T$"
  },
  {
      "name": "Trinidad and Tobago",
      "code": "TT",
      "dial_code": "+1868",
      "flag": "🇹🇹",
      "currency_name": "Trinidad and Tobago Dollar",
      "currency": "TTD",
      "currency_symbol": "$"
  },
  {
      "name": "Tunisia",
      "code": "TN",
      "dial_code": "+216",
      "flag": "🇹🇳",
      "currency_name": "Tunisian Dinar",
      "currency": "TND",
      "currency_symbol": "د.ت"
  },
  {
      "name": "Turkey",
      "code": "TR",
      "dial_code": "+90",
      "flag": "🇹🇷",
      "currency_name": "Turkish Lira",
      "currency": "TRY",
      "currency_symbol": "₺"
  },
  {
      "name": "Turkmenistan",
      "code": "TM",
      "dial_code": "+993",
      "flag": "🇹🇲",
      "currency_name": "Turkmenistan Manat",
      "currency": "TMT",
      "currency_symbol": "m"
  },
  {
      "name": "Tuvalu",
      "code": "TV",
      "dial_code": "+688",
      "flag": "🇹🇻",
      "currency_name": "Australian Dollar",
      "currency": "AUD",
      "currency_symbol": "$"
  },
  {
      "name": "Uganda",
      "code": "UG",
      "dial_code": "+256",
      "flag": "🇺🇬",
      "currency_name": "Ugandan Shilling",
      "currency": "UGX",
      "currency_symbol": "Sh"
  },
  {
      "name": "Ukraine",
      "code": "UA",
      "dial_code": "+380",
      "flag": "🇺🇦",
      "currency_name": "Ukrainian Hryvnia",
      "currency": "UAH",
      "currency_symbol": "₴"
  },
  {
      "name": "United Arab Emirates",
      "code": "AE",
      "dial_code": "+971",
      "flag": "🇦🇪",
      "currency_name": "UAE Dirham",
      "currency": "AED",
      "currency_symbol": "د.إ"
  },
  {
      "name": "United Kingdom",
      "code": "GB",
      "dial_code": "+44",
      "flag": "🇬🇧",
      "currency_name": "British Pound",
      "currency": "GBP",
      "currency_symbol": "£"
  },
  {
      "name": "United States",
      "code": "US",
      "dial_code": "+1",
      "flag": "🇺🇸",
      "currency_name": "United States Dollar",
      "currency": "USD",
      "currency_symbol": "$"
  },
  {
      "name": "Uruguay",
      "code": "UY",
      "dial_code": "+598",
      "flag": "🇺🇾",
      "currency_name": "Uruguayan Peso",
      "currency": "UYU",
      "currency_symbol": "$"
  },
  {
      "name": "Uzbekistan",
      "code": "UZ",
      "dial_code": "+998",
      "flag": "🇺🇿",
      "currency_name": "Uzbekistani Som",
      "currency": "UZS",
      "currency_symbol": "сўм"
  },
  {
      "name": "Vanuatu",
      "code": "VU",
      "dial_code": "+678",
      "flag": "🇻🇺",
      "currency_name": "Vanuatu Vatu",
      "currency": "VUV",
      "currency_symbol": "Vt"
  },
  {
      "name": "Vatican City",
      "code": "VA",
      "dial_code": "+39",
      "flag": "🇻🇦",
      "currency_name": "Euro",
      "currency": "EUR",
      "currency_symbol": "€"
  },
  {
      "name": "Venezuela",
      "code": "VE",
      "dial_code": "+58",
      "flag": "🇻🇪",
      "currency_name": "Venezuelan Bolívar",
      "currency": "VES",
      "currency_symbol": "Bs."
  },
  {
      "name": "Vietnam",
      "code": "VN",
      "dial_code": "+84",
      "flag": "🇻🇳",
      "currency_name": "Vietnamese Đồng",
      "currency": "VND",
      "currency_symbol": "₫"
  },
  {
      "name": "Yemen",
      "code": "YE",
      "dial_code": "+967",
      "flag": "🇾🇪",
      "currency_name": "Yemeni Rial",
      "currency": "YER",
      "currency_symbol": "﷼"
  },
  {
      "name": "Zambia",
      "code": "ZM",
      "dial_code": "+260",
      "flag": "🇿🇲",
      "currency_name": "Zambian Kwacha",
      "currency": "ZMW",
      "currency_symbol": "ZK"
  },
  {
      "name": "Zimbabwe",
      "code": "ZW",
      "dial_code": "+263",
      "flag": "🇿🇼",
      "currency_name": "Zimbabwean Dollar",
      "currency": "ZWL",
      "currency_symbol": "$"
  }
]